import React from 'react';
import PropTypes from 'prop-types';
import './AreasList.css';

import { ViewerPrimaryColorUserStyle } from '../../UserCustomization';

export function AreasListComponent({
  children,
  handleClick,
  activeMenu,
  areasToShow,
  areaAllLength,
  style }) {
  const areas = ['States', 'Regions', 'Counties', 'Communities'].filter(s => {
    return (areaAllLength[`${s}`])
      ? areaAllLength[`${s}`].length > 0 && (!areasToShow || areasToShow.indexOf(s) !== -1)
      : !areaAllLength[`${s}`] && (!areasToShow || areasToShow.indexOf(s) !== -1);
  });

  return (
    <div className="list areas" style={style}>
      <ViewerPrimaryColorUserStyle domStyle="backgroundColor">
        <div className="list-sort-bar subheader__link" >
          <ul>
            {areas.map(menu => (
              <li
                key={menu}
                className={menu.toLowerCase() === activeMenu ? 'active' : ''}
              >
                <a
                  className={`subheader__${menu.toLowerCase()}__link`}
                  tabIndex="0"
                  onClick={() => { handleClick(menu.toLowerCase()); }}
                >
                  {menu}
                </a>
              </li>
            ))}
          </ul>
        </div>
      </ViewerPrimaryColorUserStyle>
      {children}
    </div>
  );
}

AreasListComponent.propTypes = {
  children: PropTypes.arrayOf(PropTypes.node),
  handleClick: PropTypes.func.isRequired,
  activeMenu: PropTypes.string.isRequired,
  areasToShow: PropTypes.arrayOf(PropTypes.string),
  style: PropTypes.object,
  areaAllLength: PropTypes.objectOf(PropTypes.array),
};

export default AreasListComponent;



// WEBPACK FOOTER //
// ./src/components/List/Areas/AreasList.js